import { useQuery } from '@tanstack/react-query';
import { getRFAverageMetrics, RFMetricsResponse } from '../../services/network/form30RFMetrics-api';

interface UseFetchRFMetricsParams {
    year: number | null;
    enabled?: boolean;
}

export const useFetchRFMetrics = ({
    year,
    enabled = true
}: UseFetchRFMetricsParams) => {
    const shouldFetch = enabled && !!year;

    const { data, isLoading, isError, error, refetch } = useQuery<RFMetricsResponse>({
        queryKey: ['rfMetrics', year],
        queryFn: async () => {
            if (!year) {
                throw new Error('Отсутствует год');
            }
            return await getRFAverageMetrics(year);
        },
        enabled: shouldFetch,
        staleTime: 5 * 60 * 1000,
        retry: 2,
    });

    return {
        rfMetricsData: data?.data || null,
        isLoading,
        isError,
        error,
        refetch
    };
};
